export const screenshots = [
  {
    url: "https://static.storm-byte.dev/Rotating_Globe_cropped.webm",
    fallbackUrl: "https://static.storm-byte.dev/Rotating_Globe_cropped.mp4",
    title: "Explore Your World",
    description: "Navigate and discover content across the globe",
  },
  {
    url: "https://static.storm-byte.dev/Swiping_Posts_cropped.webm",
    fallbackUrl: "https://static.storm-byte.dev/Swiping_Posts_cropped.mp4",
    title: "See What's Trending",
    description: "Create and explore realtime feeds to see events as they happen",
  },
  {
    url: "https://static.storm-byte.dev/Livestreaming_Anywhere_2_cropped.webm",
    fallbackUrl: "https://static.storm-byte.dev/Livestreaming_Anywhere_2_cropped.mp4",
    title: "Location-based Livestreaming",
    description: "Stream directly to the map. Share your Livestream with everyone — or only with your private communities.",
  },
  {
    url: "https://static.storm-byte.dev/Explore_Geographic_Layers_cropped.webm",
    fallbackUrl: "https://static.storm-byte.dev/Explore_Geographic_Layers_cropped.mp4",
    title: "Explore Geographic Layers",
    description: "Discover location-based communities for the areas you're interested in",
  },
  {
    url: "https://static.storm-byte.dev/Set_And_Draw_Layer_combined_cropped.webm",
    fallbackUrl: "https://static.storm-byte.dev/Set_And_Draw_Layer_combined_cropped.mp4",
    title: "Create Custom Layers",
    description: "Make your own location-based communities around any topic",
  },
  {
    url: "https://static.storm-byte.dev/Share_To_Other_Platforms_cropped.webm",
    fallbackUrl: "https://static.storm-byte.dev/Share_To_Other_Platforms_cropped.mp4",
    title: "Cross Platform Sharing",
    description: "Share posts and layer communities to any platform",
  },
  {
    url: "https://static.storm-byte.dev/Message_Other_Users_cropped.webm",
    fallbackUrl: "https://static.storm-byte.dev/Message_Other_Users_cropped.mp4",
    title: "Message Other Users",
    description: "Invite others to your layers or communicate with local experts",
  },
];

export const personaSections: Array<{
  media: string;
  type: 'video' | 'image';
  title: string;
  tagline: string;
  description: string;
}> = [
  {
    media: "https://static.storm-byte.dev/4334edb7-5dbb-4938-9940-5bb1d168c98f/index.m3u8",
    type: "video",
    title: "The Citizen Journalist",
    tagline: "Show the world what's happening on the ground",
    description: "Livestream from the scene directly to the map"
  },
  {
    media: "https://static.storm-byte.dev/Hereabout_Outdoor_Enthusiast_Profile_Animated_web_compressed.mp4",
    type: "video",
    title: "The Outdoor Enthusiast",
    tagline: "Mark the wild. Share the intel.",
    description: "Keep your best spots and trail knowledge organized"
  },
  {
    media: "https://static.storm-byte.dev/Hereabout_Traveler_Profile_Animated_web.mp4",
    type: "video",
    title: "The Traveler",
    tagline: "Make your map a story",
    description: "Turn every stop into a memory that lives on the map"
  },
  {
    media: "https://static.storm-byte.dev/Herabout_Community_Builder_Profile_Filled_In.jpg",
    type: "image",
    title: "The Community Builder",
    tagline: "Build a Layer. Grow a place.",
    description: "Create a focused, hyper-local space that stays on-topic"
  },
  {
    media: "https://static.storm-byte.dev/Hereabout_Artist_Profile_Filled_In.jpg",
    type: "image",
    title: "The Casual Explorer",
    tagline: "Capture your neighborhood",
    description: "Document local moments and share what's around you"
  }
];
